export const VALIDATION = {
	short_text: 200,
};
